export async function copyTextToClipboard(value: string) {
  let clipboardError: unknown = null;

  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(value);
      return;
    } catch (error) {
      clipboardError = error;
    }
  }

  if (typeof document !== 'undefined') {
    const textArea = document.createElement('textarea');
    const activeElement =
      typeof HTMLElement !== 'undefined' &&
      document.activeElement instanceof HTMLElement
        ? document.activeElement
        : null;

    textArea.value = value;
    textArea.setAttribute('readonly', '');
    textArea.style.left = '-9999px';
    textArea.style.opacity = '0';
    textArea.style.position = 'fixed';
    textArea.style.top = '0';

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    textArea.setSelectionRange(0, value.length);

    try {
      if (document.execCommand('copy')) {
        return;
      }
    } catch (error) {
      clipboardError = error;
    } finally {
      document.body.removeChild(textArea);
      activeElement?.focus();
    }
  }

  if (
    typeof DOMException !== 'undefined' &&
    clipboardError instanceof DOMException &&
    clipboardError.name === 'NotAllowedError'
  ) {
    throw new Error(
      'Your browser blocked clipboard access. Please copy the link manually.',
    );
  }

  throw new Error('Clipboard copy is not available on this device.');
}
